import cx from "classnames";
import React, {
	type FC,
	type InputHTMLAttributes,
	useEffect,
	useRef,
} from "react";

import parse, {
	type HTMLReactParserOptions,
	type DOMNode,
	Element,
	domToReact,
} from "html-react-parser";
import { Footnote } from "../../components/Footnote";
import { TextParagraphContext } from "../../containers/TextParagraph/TextParagraph.context";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
	html: string;
	footnotes: Queries.FieldFootnoteFragment[];
}

export const TextAreaParsed: FC<Props> = ({
	className,
	footnotes,
	html,
	...props
}) => {
	const options: HTMLReactParserOptions = {
		replace: ({ attribs, children }: DOMNode) => {
			if (!attribs) {
				return;
			}
			if (attribs.class === "embedded-entity") {
				return (
					<>
						<Footnote attribs={attribs}>{children}</Footnote>
					</>
				);
			}
		},
	};

	const parsedHtml = parse(html, options);

	return (
		<TextParagraphContext.Provider value={{ footNotes: footnotes }}>
			<div {...props} className={className}>
				{parsedHtml}
			</div>
		</TextParagraphContext.Provider>
	);
};

export default TextAreaParsed;
